import { Phone, Mail, MessageCircle, Building2 } from "lucide-react";

function ContactItem({ icon: Icon, title, children, testId }) {
  return (
    <div className="ye-contact-card" {...(testId ? { "data-testid": testId } : {})}>
      <div className="ye-icon-block">
        <span className="icon"><Icon size={22} /></span>
        <div>
          <h4>{title}</h4>
          {children}
        </div>
      </div>
    </div>
  );
}

function OfficeAddress({ label, address, testId }) {
  return (
    <ContactItem icon={Building2} title={label} testId={testId}>
      <p style={{ margin: 0 }}>{address}</p>
    </ContactItem>
  );
}

function ContactMap() {
  return (
    <div className="ye-contact-card" style={{ padding: 0, overflow: "hidden" }}>
      <iframe
        title="Yaduraj Enterprises office location — Sheo, Barmer, Rajasthan"
        src="https://www.google.com/maps?q=Sheo%2C+Barmer%2C+Rajasthan&output=embed"
        width="100%"
        height="280"
        style={{ border: 0, display: "block" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
        data-testid="contact-map"
      />
    </div>
  );
}

export default function ContactDetails() {
  return (
    <div>
      <OfficeAddress
        label="Registered Office — Barmer, Rajasthan"
        address="Khasra No. 2135/0039, Sheo, Barmer, Rajasthan"
        testId="contact-office-barmer"
      />
      <OfficeAddress
        label="Delhi NCR Office"
        address="Flat No. 63, Plot No. 6, Saidulajab, New Delhi"
        testId="contact-office-delhi"
      />
      <ContactItem icon={Phone} title="Phone">
        <p style={{ margin: 0 }}>
          <a href="tel:+917689912984" data-testid="contact-phone-1">+91 76899 12984</a>
          {" · "}
          <a href="tel:+917878759012" data-testid="contact-phone-2">+91 78787 59012</a>
        </p>
      </ContactItem>
      <ContactItem icon={Mail} title="Email">
        <p style={{ margin: 0 }}>
          <a href="mailto:yadurajenterprises9@gmail.com" data-testid="contact-email">yadurajenterprises9@gmail.com</a>
        </p>
      </ContactItem>
      <ContactItem icon={MessageCircle} title="WhatsApp">
        <p style={{ margin: "0 0 10px" }}>Faster than email — we usually reply within minutes during work hours.</p>
        <a
          href="https://wa.me/917689912984?text=Hello%20Yaduraj%20Enterprises%2C%20I%20want%20to%20discuss%20a%20project."
          className="ye-btn ye-btn-primary"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-whatsapp-btn"
        >
          <MessageCircle size={16} /> Chat with us on WhatsApp
        </a>
      </ContactItem>
      <ContactMap />
    </div>
  );
}
